import{a}from"./chunk-RXHER6EA.mjs";var e=class extends a{};export{e as a};
//# sourceMappingURL=chunk-2V636AYW.mjs.map